<template>
    <x-modal :id="id" title="Webhook Visitor Settings">
        <x-form-group label="Field Mapping">
            <p>
                Silakan sesuaikan <b>Internal Field Name</b> di Cognito dengan
                tabel berikut. Klik
                <a
                    href="https://www.cognitoforms.com/support/49/calculations/developer-mode"
                    target="_blank"
                    >di sini</a
                >
                untuk informasi lebih lanjut tentang cara setting
                <b>Internal Field Name</b> di Cognito Forms.
            </p>
            <x-table :headers="['Field', 'Keterangan', 'Wajib?']">
                <tr>
                    <td><code>name</code></td>
                    <td>Nama pendaftar</td>
                    <td>Ya</td>
                </tr>
                <tr>
                    <td><code>gender</code></td>
                    <td>
                        Jenis Kelamin boleh dikosongkan, tapi bila tidak kosong
                        harus diisi dengan
                        <code>male</code>, <code>female</code>,
                        <code>Laki-laki</code>, <code>Pria</code>,
                        <code>Wanita</code>, atau <code>Perempuan</code>.
                        Pengecekan bersifat case-insensitive.
                    </td>
                    <td>Ya</td>
                </tr>
                <tr>
                    <td><code>birthplace</code></td>
                    <td>Tempat lahir</td>
                    <td>Ya</td>
                </tr>
                <tr>
                    <td><code>birthdate</code></td>
                    <td>Tanggal lahir</td>
                    <td>Ya</td>
                </tr>
                <tr>
                    <td><code>phone</code></td>
                    <td>No HP</td>
                    <td>Ya</td>
                </tr>
                <tr>
                    <td><code>address</code></td>
                    <td>Alamat</td>
                    <td>Ya</td>
                </tr>
                <tr>
                    <td><code>email</code></td>
                    <td>Alamat Email</td>
                    <td>Tidak</td>
                </tr>
                <tr>
                    <td><code>marital_status</code></td>
                    <td>
                        Status pernikahan
                        <code>Janda / Duda</code> atau <code>Menikah</code> atau
                        <code>Belum Menikah</code> atau
                        <code>Belum Ditentukan</code>
                    </td>
                    <td>Ya</td>
                </tr>
            </x-table>
        </x-form-group>
        <x-form-group label="Webhook URL">
            <p v-if="id">
                Copy & paste link berikut ke <b>Submit Entry Endpoint</b> di
                Cognito Form bersangkutan. Klik
                <a
                    href="https://www.cognitoforms.com/support/66/data-integration/webhooks#viewing-a-post-from-cognito-forms"
                    target="_blank"
                    >di sini</a
                >
                untuk informasi lebih lanjut tentang cara setting
                <b>Submit Entry Endpoint</b> di Cognito Forms.
            </p>
            <span v-else>
                Silakan simpan form ini terlebih dahulu untuk mendapatkan
                <b>Webhook URL</b> yang akan digunakan di Cognito Forms.
            </span>
            <input
                v-if="id"
                type="text"
                class="form-control"
                readonly
                :value="webhook_url"
            />
        </x-form-group>

        <template #footer>
            <x-close-modal-button />
        </template>
    </x-modal>
</template>

<script>
import XModal from "../../components/XModal.vue";
import XFormGroup from "../../components/XFormGroup.vue";
import XTable from "../../components/XTable.vue";
import XCloseModalButton from "../../components/XCloseModalButton.vue";

export default {
    components: { XModal, XFormGroup, XTable, XCloseModalButton },
    props: {
        id: {
            type: String,
            default: "webhook-modal",
        },
    },
    computed: {
        webhook_url() {
            return `${window.location.origin}/visitors/webhook?token=e3f1a9b7c4d2e8f0a1b3c5d7e9f0123456789abcdef0123456789abcdef0123`;
        },
    },
};
</script>
